import { Container } from "@mui/material";
import { FC } from "react";

import { VehiclesManagement } from "../components";

export const Vehicles: FC = () => {
  return (
    <Container sx={{ flexGrow: 1 }}>
      <VehiclesManagement />
    </Container>
  );
};
